export default __webpack_public_path__ + "static/media/arrow.2395a3dd.svg";